import { config } from '@config/config';
export const apiEndpoints = {
    action: () => `${config.FASTERACIONEZ_API_URL}/analyze/action`,
    analyzer: () => `${config.FASTERACIONEZ_API_URL}/analyze/analyzer`,
    dictioner: () => `${config.FASTERACIONEZ_API_URL}/analyze/dictioner`,
    feedback: () => `${config.FASTERACIONEZ_API_URL}/analyze/feedback`,
    inflector: () => `${config.FASTERACIONEZ_API_URL}/analyze/inflector`,
    lemmatizer: () => `${config.FASTERACIONEZ_API_URL}/analyze/lemmatizer`,
};
